import {cloneDeep, sortBy} from 'lodash';
import {
	concatMergeStrategy,
	deleteRelationship,
	isApiResponseOk,
	normalize,
	normalizedCreate,
	normalizedDelete,
	normalizedUpdate,
	truthyWinsMergeStrategy
} from '../../util/utils';
import {
	entities,
	itControlApproachType,
	specialBodiesSlices,
	HttpStatusCodes,
	TaskStatusIds
} from '../../util/uiconstants';
import {
	BODIES_SPECIAL_CLIENTSIDE_FILTERS,
	CREATE_ITAPPLICATION_ITPROCESS_RELATIONSHIP,
	CREATE_ITAPPLICATION_SO,
	CREATE_ITCONTROL,
	CREATE_ITPROCESS,
	CREATE_ITRISK,
	CREATE_RISK,
	DELETE_ITAPPLICATION,
	DELETE_ITAPPLICATION_ITPROCESS_RELATION,
	DELETE_ITCONTROL,
	DELETE_ITPROCESS,
	DELETE_ITRISK,
	DELETE_RISK,
	GET_ALL_ITCONTROLS,
	GET_ALL_ITPROCESSES,
	GET_ALL_ITPROCESSES_WITHOUT_PAGINATION,
	GET_ALL_IT_APPLICATIONS,
	GET_ALL_SCOTS,
	GET_ALL_TASKS,
	ADD_RELATED_TASK,
	GET_ENGAGEMENT_ALL_ITCONTROLS,
	GET_ENGAGEMENT_ALL_SCOTS,
	GET_ITCONTROL_BY_ID,
	GET_IT_APPLICATION,
	GET_ITAPPSO_BY_ID,
	GET_RISKS,
	GET_RISKS_FACTORS,
	GET_RISK_TYPES,
	IT_APPLICATION_SELECTED,
	IT_PROCESS_SELECTED,
	REFRESH_UNRELATED_ITCONTROLS,
	RELATE_ITRISK_ITCONTROL,
	RELATE_TASK_ITPROCESS,
	UNRELATE_ITRISK_ITCONTROL,
	UNRELATE_TASK_ITPROCESS,
	UPDATE_CONTROL,
	UPDATE_ITAPPLICATION,
	UPDATE_ITCONTROL,
	UPDATE_ITPROCESS,
	UPDATE_ITRISK,
	UPDATE_RISK_FACTOR_RELATION,
	UPDATE_SCOT,
	UPDATE_RISK,
	PUT_WCGW,
	GET_FORM_BODIES_BY_SECTIONID,
	UPDATE_FORM_BODY_RELATEOBJECTS_AFTER_RESPONSE,
	GET_ITPROCESS_BY_ID,
	GET_CONTROL_BY_ID
} from '../../actions/actiontypes';
import {
	normalizeScots,
	normalizeItProcesses,
	normalizeItApplications,
	normalizeItControls,
	normalizeRiskTypes,
	normalizeRisks,
	normalizeRiskFactors,
	normalizeEntities,
	normalizeControls
} from '../Common/bodiesSpecial';
import initialstate from '../initialstate';

export default function reducer(state = initialstate.bodiesSpecial, action) {
	let updatedState;

	switch (action.type) {
		case GET_ALL_SCOTS: {
			return {
				...normalizeScots(action.response.data, state),
				metadata: getMetadata(
					state,
					action.response.data,
					action.bodyId,
					action.entityId,
					action.response.page,
					action.response.pages,
					action.response.totalEntityCount,
					action.clientFilters
				)
			};
		}

		case GET_ENGAGEMENT_ALL_SCOTS: {
			const scots = action.response.data.map((scot) => ({
				...scot,
				controls: scot.controls?.map((control) => control.id) || [],
				itApplications: scot.itApplications?.map((itApplication) => itApplication.id) || []
			}));

			const controls = action.response.data
				.flatMap((scot) => scot.controls || [])
				.map((control) => {
					const relatedScots = scots
						.filter((scot) => scot.controls?.some((id) => id === control.id))
						.map((scot) => scot.id);

					return {
						...control,
						itApplications: control.itApplications?.map((itApplication) => itApplication.id) || [],
						scots: relatedScots || []
					};
				});

			const metadata = {
				...state.metadata,
				[action.isServiceOrganization ? 'allSoSCOTs' : 'allITAppSCOTs']: [...scots.map((scot) => scot.id)]
			};

			return {
				...state,
				metadata,
				scots: normalize(scots, undefined, state.scots, truthyWinsMergeStrategy),
				controls: normalize(controls, 'id', state.controls, truthyWinsMergeStrategy)
			};
		}

		case GET_ALL_ITPROCESSES: {
			if (action.response && action.response.data) {
				return {
					...normalizeItProcesses(action.response.data, state),
					metadata: getMetadata(
						state,
						action.response.data,
						action.bodyId,
						action.entityId,
						action.response.page,
						action.response.pages,
						action.response.totalEntityCount,
						action.clientFilters
					)
				};
			} else {
				return state;
			}
		}

		case GET_ITPROCESS_BY_ID: {
			if (action.response) {
				return {
					...normalizeItProcesses([action.response], state)
				};
			} else {
				return state;
			}
		}

		case REFRESH_UNRELATED_ITCONTROLS: {
			const {bodyId} = action;

			const refreshCounter = state.metadata[bodyId].refreshItControlCounter || false;

			return {
				...state,
				metadata: {
					...state.metadata,
					[bodyId]: {
						...state.metadata[bodyId],
						// This property exists only to force the unrelated It Control counter to refresh
						refreshItControlCounter: !refreshCounter
					}
				}
			};
		}

		case BODIES_SPECIAL_CLIENTSIDE_FILTERS: {
			const {bodyId, entityName, filters} = action;

			const filtersArray = sortBy(Object.entries(filters), (filter) => {
				return filterPriority[filter[0]];
			});
			let filteredIds = null;
			if (filtersArray.length > 0) {
				filteredIds = filterFunctions[filtersArray[0][0]](
					state,
					state.metadata[bodyId]?.allIds,
					entityName,
					filtersArray[0][1]
				);
				for (let i = 1; i < filtersArray.length; i++) {
					filteredIds = filterFunctions[filtersArray[i][0]](state, filteredIds, entityName, filtersArray[i][1]);
				}
			}

			return {
				...state,
				metadata: {
					...state.metadata,
					[bodyId]: {
						...state.metadata[bodyId],
						filteredIds: filteredIds
					}
				}
			};
		}

		case GET_IT_APPLICATION:
		case GET_ITAPPSO_BY_ID:
		case GET_ALL_IT_APPLICATIONS: {
			if (action.response.data) {
				if (!action.bodyId) {
					return {
						...normalizeItApplications(action.response.data, state)
					};
				}
				return {
					...normalizeItApplications(action.response.data, state),
					metadata: getMetadata(
						state,
						action.response.data,
						action.bodyId,
						action.entityId,
						action.response.page,
						action.response.pages,
						action.response.totalEntityCount,
						action.clientFilters
					)
				};
			}
		}

		case DELETE_ITAPPLICATION: {
			const result = {
				...state,
				metadata: deleteMetadata(state.metadata, action.itApplicationId, entities.ItSoApplication)
			};

			result.controls = deleteRelationship(result.controls, 'itApplications', action.itApplicationId);
			result.itProcesses = deleteRelationship(result.itProcesses, 'itApplications', action.itApplicationId);
			result.scots = deleteRelationship(result.scots, 'itApplications', action.itApplicationId);

			result.itApplications = normalizedDelete(result.itApplications, action.itApplicationId);

			return result;
		}

		case DELETE_ITAPPLICATION_ITPROCESS_RELATION:
			{
				if (!action.error && state.itApplications && state.itProcesses) {
					const itApplicationId = action.itApplicationId;
					const itProcessId = action.target.id;

					const itApplication = {
						...state.itApplications.byId[itApplicationId],
						itProcesses: state.itApplications.byId[itApplicationId].itProcesses?.filter((id) => id !== itProcessId)
					};
					const itProcess = {
						...state.itProcesses.byId[itProcessId],
						itApplications: state.itProcesses.byId[itProcessId].itApplications?.filter((id) => id !== itApplicationId)
					};

					let result = {
						...state,
						itApplications: {
							...state.itApplications,
							byId: {
								...state.itApplications.byId,
								[itApplicationId]: itApplication
							}
						},
						itProcesses: {
							...state.itProcesses,
							byId: {
								...state.itProcesses.byId,
								[itProcessId]: itProcess
							}
						}
					};

					return result;
				}
			}
			break;

		case DELETE_ITPROCESS: {
			const result = {
				...state,
				metadata: deleteMetadata(state.metadata, action.itProcessId, entities.ItProcess)
			};

			if (Array.isArray(result.metadata?.allItProcesses)) {
				result.metadata.allItProcesses = result.metadata.allItProcesses.filter((id) => id !== action.itProcessId);
			}

			result.itApplications = deleteRelationship(result.itApplications, 'itProcesses', action.itProcessId);

			result.itProcesses = normalizedDelete(result.itProcesses, action.itProcessId);

			return result;
		}

		case DELETE_ITCONTROL: {
			const result = {
				...state,
				metadata: deleteMetadata(state.metadata, action.itControlId, entities.ItControl)
			};

			result.metadata = deleteMetadata(state.metadata, action.itControlId, entities.ItProcess, 'unrelatedItControls');

			// Note: ItControls dont have child relationships with other entities. That's why there aren't any calls to deleteRelationship()

			result.itControls = normalizedDelete(result.itControls, action.itControlId);

			return result;
		}

		case DELETE_ITRISK: {
			const {itRiskId: deletedItRiskId} = action;

			const itProcessId = state.itProcesses.byId[state.itRisks.byId[deletedItRiskId].itProcessId].id;

			const result = {
				...state,
				metadata: deleteMetadata(state.metadata, deletedItRiskId, entities.ItRisk)
			};

			result.itProcesses = deleteRelationship(result.itProcesses, 'itRisks', deletedItRiskId);
			const updatedItControlIds = result.itProcesses.byId[itProcessId].itControls?.filter((itControlId) =>
				result.itProcesses.byId[itProcessId].itRisks?.some((itRiskId) =>
					result.itRisks.byId[itRiskId].itControls?.includes(itControlId)
				)
			);

			result.itProcesses.byId[itProcessId] = {...result.itProcesses.byId[itProcessId], itControls: updatedItControlIds};

			result.itRisks = normalizedDelete(result.itRisks, deletedItRiskId);

			return result;
		}

		case DELETE_RISK: {
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				const riskId = action.riskId;

				const newState = {
					...state
				};

				newState.risks = normalizedDelete(newState.risks, riskId);

				return newState;
			}
			return state;
		}

		case GET_ENGAGEMENT_ALL_ITCONTROLS:
		case GET_ALL_ITCONTROLS: {
			if (action && action.response) {
				updatedState = {
					...normalizeItControls(action.response, state)
				};

				// Update metadata for a body:
				if (action.bodyId) {
					updatedState = {
						...updatedState,
						metadata: getMetadata(
							state,
							action.response?.data,
							action.bodyId,
							action.entityId,
							action.response?.page,
							action.response?.pages,
							action.response?.totalEntityCount,
							action.clientFilters,
							action.metadataKey
						)
					};
				}

				return updatedState;
			} else {
				return state;
			}
		}

		case GET_ITCONTROL_BY_ID: {
			if (action && action.response) {
				return {
					...state,
					itControls: normalize(
						[action.response],
						'itControlId',
						state.itControls || undefined,
						truthyWinsMergeStrategy
					)
				};
			} else {
				return state;
			}
		}

		case RELATE_ITRISK_ITCONTROL: {
			if (action && action.response) {
				const {itRiskId, itControlId} = action.response;

				const itRisk = {...state.itRisks.byId[itRiskId]};
				if (!itRisk.itControls) {
					itRisk.itControls = [itControlId];
				} else if (!itRisk.itControls.includes(itControlId)) {
					itRisk.itControls = itRisk.itControls.concat(itControlId);
				}

				// Add the new ITControl to the itProcesses related to the itRisk
				const itProcessesRelatedToItRisk = getRelatedEntities(state.itProcesses.byId, 'itRisks', itRiskId);

				if (itProcessesRelatedToItRisk && itProcessesRelatedToItRisk.length > 0) {
					itProcessesRelatedToItRisk.forEach((itProcess) => {
						if (!itProcess.itControls.includes(itControlId)) {
							itProcess.itControls = itProcess.itControls.concat(itControlId);
						}
					});
				}

				updatedState = {
					...state,
					itRisks: normalize([itRisk], undefined, state.itRisks, truthyWinsMergeStrategy),
					itProcesses: normalize(itProcessesRelatedToItRisk, undefined, state.itProcesses, truthyWinsMergeStrategy)
				};

				return updatedState;
			} else {
				return state;
			}
		}

		case UNRELATE_ITRISK_ITCONTROL: {
			if (!action.error) {
				const {itRiskId, itControlId} = action;
				const itRisksById = state.itRisks.byId;

				const itRisk = {...itRisksById[itRiskId]};
				if (itRisk.itControls && itRisk.itControls.includes(itControlId)) {
					itRisk.itControls = itRisk.itControls.filter((id) => id !== itControlId);
				}

				// Remove the ITControl to the itProcesses related to the itRisk
				const itProcessesRelatedToItRisk = getRelatedEntities(state.itProcesses.byId, 'itRisks', itRiskId);

				if (itProcessesRelatedToItRisk && itProcessesRelatedToItRisk.length > 0) {
					itProcessesRelatedToItRisk.forEach((itProcess) => {
						// No other itRisk is related to the itControl being removed
						if (
							!itProcess.itRisks.some(
								(_itRiskId) =>
									_itRiskId !== itRiskId &&
									itRisksById[_itRiskId].itControls &&
									itRisksById[_itRiskId].itControls.includes(itControlId)
							)
						) {
							// The itProcess is related to the itControlId
							if (itProcess.itControls.includes(itControlId)) {
								itProcess.itControls = itProcess.itControls.filter((id) => id !== itControlId);
							}
						}
					});
				}

				updatedState = {
					...state,
					itRisks: normalize([itRisk], undefined, state.itRisks, truthyWinsMergeStrategy),
					itProcesses: normalize(itProcessesRelatedToItRisk, undefined, state.itProcesses, truthyWinsMergeStrategy)
				};

				return updatedState;
			} else {
				return state;
			}
		}

		case GET_ALL_TASKS: {
			if (action && action.response && action.response?.taskGroups && action.response?.taskGroups?.length > 0) {
				const tasks = action.response.taskGroups[0].tasks;
				const relatedTasksCollection = tasks.map((t) => {
					const taskInStore = {...state.relatedTasks.byId[t.id]};
					return taskInStore
						? {
								...populateRelevantTaskAttributes(t),
								itProcessId: taskInStore.itProcessId,
								itProcessTaskId: taskInStore.itProcessTaskId
						  }
						: {
								...populateRelevantTaskAttributes(t),
								itProcessId: null,
								itProcessTaskId: null
						  };
				});
				const relatedTasks = normalize(relatedTasksCollection, undefined, undefined, truthyWinsMergeStrategy);
				return {
					...state,
					relatedTasks
				};
			} else {
				return state;
			}
		}

		case ADD_RELATED_TASK: {
			if (action.taskAttributes) {
				const task = mapTaskAttributes(action.taskAttributes);
				const byIdObject = {
					...state.relatedTasks?.byId,
					[action.taskAttributes.taskId]: task
				};

				const updatedAllIds = cloneDeep(state.relatedTasks.allIds);
				updatedAllIds.push(action.taskAttributes.taskId);

				return {
					...state,
					relatedTasks: {
						...state.relatedTasks,
						byId: byIdObject,
						allIds: updatedAllIds
					}
				};
			}

			return state;
		}

		case GET_RISKS_FACTORS: {
			if (action.response && !action.error) {
				let replace = action.bodyId ? true : false;
				updatedState = normalizeRiskFactors(action.response, state, replace);
				if (action.bodyId) {
					updatedState = {
						...updatedState,
						metadata: getMetadata(
							state,
							action.response,
							action.bodyId,
							action.entityId,
							action.response.page,
							action.response.pages,
							action.response.totalEntityCount,
							action.clientFilters
						)
					};
				}

				return {
					...state,
					...updatedState
				};
			} else {
				return state;
			}
		}

		case UPDATE_RISK_FACTOR_RELATION: {
			if (action.response && !action.error) {
				const riskFactor = {
					...action.response,
					riskId: action.response.riskId || null,
					rationale: action.response.rationale || null
				};

				return {
					...state,
					riskFactors: normalize([riskFactor], undefined, state.riskFactors)
				};
			} else {
				return state;
			}
		}

		case CREATE_RISK: {
			if (action.response && !action.error) {
				return {
					...state,
					risks: normalize([action.response], undefined, state.risks, truthyWinsMergeStrategy)
				};
			} else {
				return state;
			}
		}

		case UPDATE_RISK: {
			if (action.response && !action.error) {
				const _updatedRisk = {
					...state.risks,
					byId: {
						...state.risks.byId,
						[action.response.id]: {
							...state.risks.byId[action.response.id],
							riskName: action.response.riskName,
							entityName: action.response.riskName
						}
					}
				};

				return {
					...state,
					risks: _updatedRisk
				};
			}

			return state;
		}

		case PUT_WCGW: {
			if (action.response) {
				const _updatedWcgw = {
					...state.wcgws,
					byId: {
						...state.wcgws.byId,
						[action.response.id]: {
							...state.wcgws.byId[action.response.id],
							wcgwName: action.response.wcgwName,
							entityName: action.response.wcgwName
						}
					}
				};

				return {
					...state,
					wcgws: _updatedWcgw
				};
			}

			return state;
		}

		case GET_RISK_TYPES: {
			if (action.response && action.response.data) {
				updatedState = normalizeRiskTypes(action.response.data, state.riskTypes);

				if (action.bodyId) {
					updatedState = {
						...updatedState,
						metadata: getMetadata(
							state,
							action.response.data,
							action.bodyId,
							action.entityId,
							action.response.page,
							action.response.pages,
							action.response.totalEntityCount,
							action.clientFilters
						)
					};
				}

				return {
					...state,
					...updatedState
				};
			} else {
				return state;
			}
		}

		case GET_RISKS: {
			if (action.response && !action.error) {
				updatedState = normalizeRisks(action.response.data, state);

				if (action.bodyId) {
					updatedState = {
						...updatedState,
						metadata: getMetadata(
							state,
							action.response.data,
							action.bodyId,
							action.entityId,
							action.response.page,
							action.response.pages,
							action.response.totalEntityCount,
							action.clientFilters
						)
					};
				}

				return {
					...state,
					...updatedState
				};
			}
			return state;
		}

		case RELATE_TASK_ITPROCESS: {
			if (action.response && !action.error) {
				const {taskId, itProcessId} = action.response;
				const itProcess = {...state.itProcesses.byId[itProcessId]};
				if (itProcess.relatedTasks && !itProcess.relatedTasks.includes(taskId)) {
					itProcess.relatedTasks = itProcess.relatedTasks.concat(taskId);
				} else {
					itProcess.relatedTasks = [taskId];
				}

				updatedState = {
					...state,
					itProcesses: normalize([itProcess], undefined, state.itProcesses, truthyWinsMergeStrategy)
				};

				return updatedState;
			} else {
				return state;
			}
		}

		case UNRELATE_TASK_ITPROCESS: {
			if (action && !action.error) {
				const {taskId, itProcessId} = action;
				const itProcess = {...state.itProcesses.byId[itProcessId]};
				if (itProcess.relatedTasks && itProcess.relatedTasks.includes(taskId)) {
					itProcess.relatedTasks = itProcess.relatedTasks.filter((realtedTaskId) => realtedTaskId !== taskId);
				}

				updatedState = {
					...state,
					itProcesses: normalize([itProcess], undefined, state.itProcesses, truthyWinsMergeStrategy)
				};

				return updatedState;
			} else {
				return state;
			}
		}

		case CREATE_ITAPPLICATION_ITPROCESS_RELATIONSHIP: {
			if (action.response && !action.error) {
				const {itApplicationId, itProcessId} = action.response;

				const itApplication = {
					...state.itApplications.byId[itApplicationId],
					itProcesses: sortBy(
						state.itApplications.byId[itApplicationId].itProcesses.concat(itProcessId),
						(id) => state.itProcesses.byId[id].itProcessName
					)
				};
				const itProcess = {
					...state.itProcesses.byId[itProcessId],
					itApplications: sortBy(
						state.itProcesses.byId[itProcessId].itApplications.concat(itApplicationId),
						(id) => state.itApplications.byId[id].itApplicationName
					)
				};

				updatedState = {
					...state,
					itApplications: {
						...state.itApplications,
						byId: {
							...state.itApplications.byId,
							[itApplicationId]: itApplication
						}
					},
					itProcesses: {
						...state.itProcesses,
						byId: {
							...state.itProcesses.byId,
							[itProcessId]: itProcess
						}
					}
				};

				return updatedState;
			}
			return state;
		}

		case IT_PROCESS_SELECTED: {
			return selectEntity(state, action, 'itProcesses', 'itApplications');
		}

		case IT_APPLICATION_SELECTED: {
			return selectEntity(state, action, 'itApplications', 'itProcesses');
		}

		case CREATE_ITPROCESS: {
			if (!state.hasOwnProperty('itProcesses') || action.error) {
				return state;
			}

			const response = {
				...action.response,
				itApplications: action.response?.itApplications || []
			};

			updatedState = {
				itProcesses: normalizedCreate(state.itProcesses, response)
			};

			if (response.relatedTasks && state.hasOwnProperty('relatedTasks')) {
				const relatedTasks = cloneDeep(state.relatedTasks);
				response.relatedTasks.forEach((taskId) => {
					if (relatedTasks.byId.hasOwnProperty(taskId)) {
						const relatedTask = relatedTasks.byId[taskId];
						if (Array.isArray(relatedTask.itProcessId)) {
							relatedTask.itProcessId.push(response.id);
						} else {
							relatedTask.itProcessId = [response.id];
						}
					}
				});

				updatedState.relatedTasks = relatedTasks;
			}

			// Merge current store state with updated state:
			updatedState = {
				...state,
				...updatedState
			};

			// Update metadata slices that show ITProcesses (entityId == ItProcess)
			updatedState = {
				...updatedState,
				metadata: updateMetadata(updatedState.metadata, response.id, entities.ItProcess)
			};

			return updatedState;
		}

		case UPDATE_ITPROCESS: {
			if (!state.hasOwnProperty('itProcesses') || action.error) {
				return state;
			}

			if (!state.itProcesses?.allIds?.includes(action.response.id)) {
				return state;
			}

			const _updatedItProcess = {
				...state.itProcesses,
				byId: {
					...state.itProcesses.byId,
					[action.response.id]: {
						...state.itProcesses.byId[action.response.id],
						itProcessName: action.response.itProcessName,
						entityName: action.response.itProcessName
					}
				}
			};

			return {
				...state,
				itProcesses: _updatedItProcess
			};
		}

		case CREATE_ITRISK: {
			if (!state.hasOwnProperty('itProcesses') || action.error) {
				return state;
			}

			const itProcessId = action.meta.api.data.itprocessId;
			if (!state.itProcesses?.allIds?.includes(itProcessId)) {
				return state;
			}

			const itProcess = state.itProcesses.byId[itProcessId];

			const itRiskArray = Array.isArray(itProcess.itRisks)
				? [...itProcess.itRisks, action.response.id]
				: [action.response.id];

			const _itProcesses = {
				...state.itProcesses,
				byId: {
					...state.itProcesses.byId,
					[itProcessId]: {
						...itProcess,
						itRisks: itRiskArray
					}
				}
			};

			const _itRisks = state.hasOwnProperty('itRisks')
				? normalize([{...action.response, itProcessId}], undefined, state.itRisks, concatMergeStrategy)
				: normalize([{...action.response, itProcessId}]);

			return {
				...state,
				itProcesses: _itProcesses,
				itRisks: _itRisks
			};
		}

		case CREATE_ITAPPLICATION_SO: {
			if (!state.hasOwnProperty('itApplications') || action.error) {
				return state;
			}

			const response = {
				...action.response,
				itProcesses: action.response.itProcesses || []
			};

			updatedState = {
				itApplications: normalizedCreate(state.itApplications, response)
			};

			if (response.scots && state.hasOwnProperty('scots')) {
				const scots = cloneDeep(state.scots);
				response.scots.forEach((scotId) => {
					if (scots.byId.hasOwnProperty(scotId)) {
						const scot = scots.byId[scotId];
						if (Array.isArray(scot.itApplications)) {
							scot.itApplications.push(response.id);
						} else {
							scot.itApplications = [response.id];
						}
					}
				});

				updatedState.scots = scots;
			}

			if (response.controls && state.hasOwnProperty('controls')) {
				const controls = cloneDeep(state.controls);
				response.controls.forEach((controlId) => {
					if (controls.byId.hasOwnProperty(controlId)) {
						const control = controls.byId[controlId];
						if (Array.isArray(control.itApplications)) {
							control.itApplications.push(response.id);
						} else {
							control.itApplications = [response.id];
						}
					}
				});

				updatedState.controls = controls;
			}

			// Merge current store state with updated state:
			updatedState = {
				...state,
				...updatedState
			};

			// Update metadata slices that show ITApplications (entityId == ItApp)
			updatedState = {
				...updatedState,
				metadata: updateMetadata(updatedState.metadata, response.id, entities.ItSoApplication)
			};

			return updatedState;
		}

		case UPDATE_ITRISK: {
			if (!state.hasOwnProperty('itRisks') || action.error) {
				return state;
			}

			if (!state.itRisks?.allIds?.includes(action.response.id)) {
				return state;
			}

			const itProcessId = action.meta.api.data.itprocessId;
			const _itRisk = state.itRisks.byId[action.response.id];

			let _updatedItRisks = {
				...state.itRisks,
				byId: {
					...state.itRisks.byId,
					[action.response.id]: {
						..._itRisk,
						...action.response,
						entityName: action.response.itRiskName
					}
				}
			};

			if (action.response.hasNoITGC && state.itControls && Array.isArray(_itRisk.itControls)) {
				const itProcess = state.itProcesses.byId[itProcessId];

				const relatedITControls = state.itControls.allIds
					.filter((id) => _itRisk.itControls.includes(id))
					.map((id) => state.itControls.byId[id]);

				const itGcs = relatedITControls
					.filter((ic) => ic.itApproachTypeId === itControlApproachType.controls)
					.map((ic) => ic.id);

				const _itProcesses = {
					...state.itProcesses,
					byId: {
						...state.itProcesses.byId,
						[itProcessId]: {
							...itProcess,
							itControls: Array.isArray(itProcess.itControls)
								? itProcess.itControls.filter((id) => !itGcs.includes(id))
								: itProcess.itControls
						}
					}
				};

				_updatedItRisks = {
					...state.itRisks,
					byId: {
						...state.itRisks.byId,
						[action.response.id]: {
							..._itRisk,
							...action.response,
							itControls: _itRisk.itControls.filter((id) => !itGcs.includes(id))
						}
					}
				};

				return {
					...state,
					itProcesses: _itProcesses,
					itRisks: _updatedItRisks
				};
			}

			return {
				...state,
				itRisks: _updatedItRisks
			};
		}

		case CREATE_ITCONTROL: {
			const itRiskId = action.meta.api.data.itRiskId;
			if (!state.itRisks?.allIds?.includes(itRiskId) || action.error) {
				return state;
			}

			const itRisk = state.itRisks.byId[itRiskId];
			const itProcessId = action.itProcessId;

			const itControlArray = Array.isArray(itRisk.itControls)
				? [...itRisk.itControls, action.response.id]
				: [action.response.id];

			const _itRisks = {
				...state.itRisks,
				byId: {
					...state.itRisks.byId,
					[itRiskId]: {
						...itRisk,
						itControls: itControlArray
					}
				}
			};

			const newControl = {
				...action.response,
				...{itProcessId, itRiskId}
			};

			const _itControls = normalize([newControl], undefined, state.itControls, concatMergeStrategy);

			const itProcess = state.itProcesses.byId[itRisk.itProcessId];
			const itControlsArray = Array.isArray(itProcess.itControls)
				? [...itProcess.itControls, newControl.id]
				: [newControl.id];

			const _itProcesses = {
				...state.itProcesses,
				byId: {
					...state.itProcesses.byId,
					[itRisk.itProcessId]: {
						...itProcess,
						itControls: itControlsArray
					}
				}
			};

			return {
				...state,
				itProcesses: _itProcesses,
				itRisks: _itRisks,
				itControls: _itControls
			};
		}

		case UPDATE_ITCONTROL: {
			if (!state.hasOwnProperty('itControls') || action.error) {
				return state;
			}

			if (!state.itControls?.allIds?.includes(action.response.id)) {
				return state;
			}

			const itRiskId = action.meta.api.data.itRiskId;
			const itProcessId = action.itProcessId;

			const itControlPayload = {
				...action.response,
				itProcessId: itProcessId,
				itRiskId: itRiskId,
				entityName: action.response.itControlName
			};

			const _updatedItControls = normalizedUpdate(itControlPayload.id, itControlPayload, state.itControls);

			return {
				...state,
				itControls: _updatedItControls
			};
		}

		case UPDATE_SCOT: {
			if (!state.hasOwnProperty('scots') || action.error) {
				return state;
			}

			const payload = action.meta.api.data;

			if (!state.scots?.allIds?.includes(payload.id)) {
				return state;
			}

			const scotId = payload.id;
			const scot = state.scots.byId[scotId];

			// Merge the itApplications and itSOs into one array
			let scotItApplications = [];
			scotItApplications = scotItApplications.concat(
				payload.itApplications || [],
				payload.itsOs || payload.itSOs || []
			);

			const itApplications = state.itApplications;
			let updatedItApplications = [];

			// Add / remove edited scot from itApplications in the store
			for (const id of itApplications.allIds) {
				// Get the itApp details
				let itAppDetails = {
					id: id,
					scots: itApplications.byId[id].scots ? [...itApplications.byId[id].scots] : []
				};

				if (scotItApplications.includes(id)) {
					// Current itApp is in the response -> Add it to scots collection
					if (!itAppDetails.scots.includes(scotId)) {
						itAppDetails.scots.push(scotId);
					}
				} else {
					// Current itAp is not in the response (got removed) -> Remove it from scots collection
					if (itAppDetails.scots.includes(scotId)) {
						itAppDetails.scots = itAppDetails.scots.filter((_scotId) => _scotId !== scotId);
					} else {
						// No changes made. Should not update the store.
						itAppDetails = null;
					}
				}

				if (itAppDetails) {
					updatedItApplications.push(itAppDetails);
				}
			}

			let newAllITAppSCOTsSlice;

			//Add/Remove Scot from allITAppSCOTs slice if the scot's hasItApplication flag changes.
			if (state.metadata.allITAppSCOTs !== undefined && payload.hasNoITApplication !== scot.hasNoITApplication) {
				newAllITAppSCOTsSlice = [...state.metadata.allITAppSCOTs];

				if (!payload.hasNoITApplication) {
					//Add scot to AllITAppSCOTs slice so the scot shows on the edit ItApp modal's relate scot combo.
					newAllITAppSCOTsSlice.push(scotId);
				} else {
					//Remove scot from AllITAppSCOTs slice so the scot dissapears from the edit ItApp modal's relate scot combo.
					let scotIndex = newAllITAppSCOTsSlice.indexOf(scotId);
					newAllITAppSCOTsSlice.splice(scotIndex, 1);
				}
			}

			const _scots = {
				...state.scots,
				byId: {
					...state.scots.byId,
					[payload.id]: {
						...scot,
						scotName: payload.scotName,
						strategyTypeId: payload.strategyTypeId,
						hasNoITApplication: payload.hasNoITApplication,
						scotTypes: payload.scotTypes,
						itApplications: scotItApplications,
						entityName: payload.scotName
					}
				}
			};

			return {
				...state,
				itApplications: normalize(updatedItApplications, undefined, state.itApplications, truthyWinsMergeStrategy),
				scots: _scots,
				metadata: {
					...state.metadata,
					allITAppSCOTs: newAllITAppSCOTsSlice || state.metadata.allITAppSCOTs
				}
			};
		}

		case UPDATE_CONTROL: {
			if (!state.hasOwnProperty('controls') || action.error) {
				return state;
			}

			const payload = action.meta.api.data;
			const {response} = action;

			if (!state.controls?.allIds?.includes(payload.id)) {
				return state;
			}

			const control = state.controls.byId[payload.id];

			const controlItApplications = payload.ITApplicationOrSOIds;

			const itApplications = cloneDeep(state.itApplications);

			for (const id of itApplications.allIds) {
				const itApp = itApplications.byId[id];
				if (controlItApplications && controlItApplications.includes(id) && !itApp?.controls?.includes(payload.id)) {
					if (Array.isArray(itApp.controls)) {
						itApp.controls.push(payload.id);
					} else {
						itApp.controls = [payload.id];
					}
				} else if (
					controlItApplications &&
					!controlItApplications.includes(id) &&
					itApp?.controls?.includes(payload.id)
				) {
					itApp.controls = itApp.controls.filter((controlId) => controlId !== payload.id);
				}
			}

			const _control = {
				...state.controls,
				byId: {
					...state.controls.byId,
					[payload.id]: {
						...control,
						controlName: response.controlName,
						controlTypeId: response.controlTypeId,
						controlDesignEffectivenessTypeId: response.controlDesignEffectivenessTypeId,
						controlFrequencyTypeId: response.controlFrequencyTypeId,
						hasControlTesting: response.hasControlTesting,
						itApplications: controlItApplications,
						isEffective: response.isEffective,
						isLowerRisk: response.isLowerRisk,
						isIPEManuallyTested: response.isIPEManuallyTested,
						entityName: response.controlName
					}
				}
			};

			return {
				...state,
				itApplications,
				controls: _control
			};
		}

		case UPDATE_ITAPPLICATION: {
			if (!state.hasOwnProperty('itApplications') || action.error) {
				return state;
			}

			const response = action.response;

			if (!state.itApplications?.allIds?.includes(response.id)) {
				return state;
			}

			const itApplication = state.itApplications.byId[response.id];

			const itApplications = {
				...state.itApplications,
				byId: {
					...state.itApplications.byId,
					[response.id]: {
						...itApplication,
						itApplicationName: response.itApplicationName,
						engagementId: response.engagementId,
						isServiceOrganization: response.isServiceOrganization,
						scots: response.scots,
						controls: response.controls,
						entityName: response.itApplicationName
					}
				}
			};

			const itApplicationScots = response.scots;
			const scots = cloneDeep(state.scots);

			for (const id of scots.allIds) {
				const scot = scots.byId[id];
				if (itApplicationScots.includes(id) && !scot?.itApplications?.includes(response.id)) {
					if (Array.isArray(scot.itApplications)) {
						scot.itApplications.push(response.id);
					} else {
						scot.itApplications = [response.id];
					}
				} else if (!itApplicationScots.includes(id) && scot?.itApplications?.includes(response.id)) {
					scot.itApplications = scot.itApplications.filter((id) => id !== response.id);
				}
			}

			const itApplicationControls = response.controls;
			const controls = cloneDeep(state.controls);

			for (const id of controls.allIds) {
				const control = controls.byId[id];
				if (itApplicationControls.includes(id) && !control?.itApplications?.includes(response.id)) {
					if (Array.isArray(control.itApplications)) {
						control.itApplications.push(response.id);
					} else {
						control.itApplications = [response.id];
					}
				} else if (!itApplicationControls.includes(id) && control?.itApplications?.includes(response.id)) {
					control.itApplications = control.itApplications.filter((id) => id !== response.id);
				}
			}

			return {
				...state,
				itApplications,
				scots,
				controls
			};
		}

		case GET_ALL_ITPROCESSES_WITHOUT_PAGINATION: {
			return {
				...normalizeItProcesses(action.response.data, state),
				metadata: getMetadata(
					state,
					action.response.data,
					action.bodyId,
					action.entityId,
					action.response.page,
					action.response.pages,
					action.response.totalEntityCount,
					action.clientFilters
				)
			};

			// const flattenedITRisks = action.response.data.flatMap((itProcess) => itProcess.itRisks);
			// const itRisks = normalize(flattenedITRisks, undefined);

			// const itProcesses = normalize(
			// 	action.response.data.map((itProcess) => {
			// 		return {
			// 			...itProcess,
			// 			itRisks: itProcess.itRisks?.map((itRisk) => itRisk.id)|| [],
			// 			itControls: itProcess.itControls?.map((itControl) => itControl.id) || []
			// 		};
			// 	}),
			// 	undefined,
			// 	state.itProcesses,
			// 	truthyWinsMergeStrategy
			// );

			// const metadata = {
			// 	...state.metadata,
			// 	allItProcesses: [...itProcesses.allIds]
			// };

			// return {
			// 	...state,
			// 	metadata,
			// 	itRisks,
			// 	itProcesses
			// };
		}

		case GET_FORM_BODIES_BY_SECTIONID: {
			if (!isApiResponseOk(action)) {
				return state;
			}

			const bodyRelatedObjects = action.response.flatMap((body) => body.bodyRelatedObjects);

			let updateState;

			const entityTypesId = [];

			bodyRelatedObjects.forEach((bro) => {
				if (!entityTypesId.includes(bro.entityId)) {
					entityTypesId.push(bro.entityId);
				}
			});

			for (let i = 0; i < entityTypesId.length; i++) {
				const entityTypeId = entityTypesId[i];
				const entities = bodyRelatedObjects.filter((entity) => entity.entityId === entityTypeId);
				updateState = normalizeEntities(entities, state);
			}

			let metadata = state?.metadata || {};
			for (const body of action.response.filter((b) => b.bodyRelatedObjects?.length > 0)) {
				// First level's entityId
				const mainEntityId = body.bodyRelatedObjects[0].entityId;

				metadata = {
					...metadata,
					...getMetadata(
						updateState,
						body.bodyRelatedObjects,
						body.id,
						mainEntityId,
						undefined,
						undefined,
						body.bodyRelatedObjects.length,
						undefined,
						undefined,
						(item) => ({entityId: item.entityId, entityUId: item.entityUId})
					)
				};
			}

			return {
				...state,
				...updateState,
				metadata
			};
		}

		case UPDATE_FORM_BODY_RELATEOBJECTS_AFTER_RESPONSE: {
			const response = action.response;
			const sliceName = specialBodiesSlices[response.entityId];

			return {
				...state,
				[sliceName]: {
					...state[sliceName],
					byId: {
						...state[sliceName].byId,
						[response.entityUId]: {...state[sliceName].byId[response.entityUId], ...response}
					}
				}
			};
		}

		case GET_CONTROL_BY_ID: {
			if (!state.hasOwnProperty('controls') || action.error) {
				return state;
			}

			return {
				state,
				...normalizeControls(action.response, state)
			};
		}

		default:
			return state;
	}
}

function getRelatedEntities(entitiesById, navigationPropertyName, entityUId) {
	if (entitiesById && navigationPropertyName && entityUId) {
		return Object.values(entitiesById)
			.filter((entity) => entity[navigationPropertyName] && entity[navigationPropertyName].includes(entityUId))
			.map((entity) => {
				return {...entity};
			});
	}
}

/**
 * Updates the metadata prop accordingly.
 * @param {object} state The current state with the metadata prop in it.
 * @param {Array} data The data being handled.
 * @param {number} bodyId The body's Id.
 * @param {number} entityId The body's main entity's Id.
 * @param {number} page Page number if pagination is available.
 * @param {number} pages Page count if pagination is available.
 * @param {number} totalEntityCount Total entity count (without pagination).
 * @param {object} clientFilters Client-side flters to be applied on the body.
 * @param {string} keyname The key in which the Id collection is being put, defaults to allIds.
 * @param {function} customEntityMapper A custom entity mapper to be used.
 * @returns {object} A new object with the updated metadata.
 */
export function getMetadata(
	state,
	data,
	bodyId,
	entityId,
	page = 1,
	pages = 1,
	totalEntityCount = 0,
	clientFilters = undefined,
	keyname = undefined,
	customEntityMapper
) {
	let entityMapper = customEntityMapper || ((item) => item.id);

	const allIds = data?.map((value) => entityMapper(value));

	if (!keyname) {
		return {
			...state.metadata,
			[bodyId]: {
				...state.metadata[bodyId],
				entityId,
				allIds,
				page,
				pages,
				totalEntityCount: totalEntityCount || allIds.length,
				clientFilters,
				filteredIds: null
			}
		};
	} else {
		return {
			...state.metadata,
			[bodyId]: {
				...state.metadata[bodyId],
				[keyname]: allIds
			}
		};
	}
}

function updateMetadata(metadata, newIds, entityId, keyName = ['allIds', 'filteredIds']) {
	if (!metadata || !newIds || entityId === null || entityId === undefined) {
		return metadata;
	}

	const result = {
		...metadata
	};

	if (!Array.isArray(keyName)) {
		keyName = [keyName];
	}
	if (!Array.isArray(newIds)) {
		newIds = [newIds];
	}

	Object.entries(metadata).forEach((entry) => {
		const [bodyId, metadataContent] = entry;
		if (metadataContent?.entityId === entityId) {
			result[bodyId] = {
				...metadata[bodyId]
			};

			keyName.forEach((key) => {
				if (result[bodyId][key]) {
					// Merge array stored in metadata with newValues (results in a unique id list)
					result[bodyId][key] = _.union(result[bodyId][key], newIds);
				}
			});
		}
	});

	return result;
}

/**
 * Removes the deleted entity Id from all other bodies that hold the same entity type.
 * @param {object} metadata The current metadata state.
 * @param {number} id The Id of the entity being deleted in the allIds array.
 * @param {number} entityId The type Id of the entity (uiconstats).
 * @param {string} keyname The key in which the Id of the entity is being deleted, defaults to allIds.
 * @returns {object} A new object with the updated metadata.
 */
function deleteMetadata(metadata, id, entityId, keyname = ['allIds', 'filteredIds']) {
	const result = {
		...metadata
	};

	if (!Array.isArray(keyname)) {
		keyname = [keyname];
	}

	Object.entries(result).forEach((entry) => {
		if (entry[1]?.entityId === entityId) {
			const bodyId = entry[0];

			result[bodyId] = {
				...result[bodyId]
			};

			keyname.forEach((key) => {
				if (result[bodyId][key]) {
					result[bodyId][key] = result[bodyId][key].filter((value) => value !== id);
				}
			});
		}
	});

	return result;
}

/**
 *
 * @param {object} state The current state.
 * @param {object} action The dispatched action.
 * @param {string} origin The entity's slice name, which is being selected.
 * @param {string} destination The entity's slice name, which is being affected by the origin entity.
 * @returns {object} The new state.
 */
function selectEntity(state, action, origin, destination) {
	const selected = !state[origin].byId[action.id].selected;
	const hasAssociation = !state[origin].byId[action.id].hasAssociation;

	const result = {
		...state,
		[origin]: {
			...state[origin],
			byId: Object.fromEntries(
				Object.entries(state[origin].byId).map((entry) => {
					// WARNING: DO NOT use !== here. entry[0] is a string while action.id is a number.
					// eslint-disable-next-line
					if (entry[0] !== action.id) {
						if (entry[1].selected) {
							if (entry[1].hasAssociation) {
								return [entry[0], {...entry[1], selected: false, hasAssociation: false}];
							}
							return [entry[0], {...entry[1], selected: false}];
						} else {
							return entry;
						}
					} else {
						if (state[destination]) {
							const destinationIds = state[origin].byId[action.id][destination];
							if (destinationIds && destinationIds.length > 0) {
								return [entry[0], {...entry[1], selected, hasAssociation}];
							}
						}
						return [entry[0], {...entry[1], selected}];
					}
				})
			)
		}
	};

	if (result[destination]) {
		const destinationIds = result[origin].byId[action.id][destination];

		result[destination] = {
			...result[destination],
			byId: Object.fromEntries(
				Object.entries(state[destination].byId).map((entry) => {
					// WARNING: DO NOT use === here. entry[0] is a string while id is a number.
					// eslint-disable-next-line
					if (destinationIds.some((id) => id === entry[0])) {
						return [entry[0], {...entry[1], selected, hasAssociation}];
					} else {
						if (entry[1].selected) {
							if (entry[1].hasAssociation) {
								return [entry[0], {...entry[1], selected: false, hasAssociation: false}];
							}
							return [entry[0], {...entry[1], selected: false}];
						} else {
							return entry;
						}
					}
				})
			)
		};
	}

	return result;
}

// Given a denormalized list of itRisks and itControls, returns a normalized (nested) version of the data
function buildItRisksForItProcess(itProcess) {
	const normalizedItRisks = [];
	const itProcessItRisks = itProcess?.itRisks;
	const itProcessItControls = itProcess?.itControls;

	if (itProcessItRisks && itProcessItRisks.length > 0 && itProcessItControls) {
		for (const itRisk of itProcessItRisks) {
			itRisk.itProcessName = itProcess.itProcessName;
			itRisk.itControls = itProcessItControls.filter((itCtrl) => itCtrl.itRiskId === itRisk.id);
			normalizedItRisks.push(itRisk);
		}
	}

	return normalizedItRisks;
}

function populateRelevantTaskAttributes(task) {
	return {
		taskName: task.name,
		taskNamePrefix: task.taskNamePrefix,
		taskNameSuffix: task.taskNameSuffix,
		knowledgeTaskTitle: task.knowledgeTaskTitle,
		taskTypeId: task.typeId,
		taskStatusId: task.statusId,
		isEPTask: task.isEPSignoffRequired,
		isEQRTask: task.isEQRSignoffRequired,
		id: task.id
	};
}

const mapTaskAttributes = (taskAttributes) => {
	return {
		itProcessId: taskAttributes.itProcessId,
		taskName: taskAttributes.title,
		taskNamePrefix: null,
		taskNameSuffix: null,
		knowledgeTaskTitle: null,
		taskTypeId: taskAttributes.taskTypeId,
		taskStatusId: TaskStatusIds.Open,
		itProcessTaskId: taskAttributes.itProcessTaskId,
		isEPTask: false,
		isEQRTask: false,
		id: taskAttributes.taskId
	};
};

const entityNameKeys = {
	itApplications: 'itApplicationName',
	itProcesses: 'itProcessName'
};

const unrelatedFilterAssociatedEntity = {
	itApplications: 'itProcesses',
	itProcesses: 'itApplications'
};

const filterFunctions = {
	searchString: (state, ids, entityName, filterValue) => {
		return filterValue
			? ids.filter((id) =>
					state[entityName].byId[id][entityNameKeys[entityName]].toLowerCase().includes(filterValue.toLowerCase())
			  )
			: ids;
	},
	filterUnassociated: (state, ids, entityName, filterValue) => {
		return filterValue
			? ids.filter((id) => state[entityName].byId[id][unrelatedFilterAssociatedEntity[entityName]]?.length === 0)
			: ids;
	}
};

const filterPriority = {
	searchString: 9,
	filterUnassociated: 0
};
